module.exports = __webpack_public_path__ + "img/1440.f4ea209e.jpg";